import _ from 'lodash';
import {Row} from '../common/forms/layout.js';
import {Column3} from '../common/forms/layout.js';
import {Column4} from '../common/forms/layout.js';
import {Column5} from '../common/forms/layout.js';
import {Column8} from '../common/forms/layout.js';
import {Column12} from '../common/forms/layout.js';

const fields = {
    // vrsta_rada: {
    //     key: 'vrsta_rada',
    //     type: 'uiSelect',
    //     templateOptions: {
    //         label: 'Vrsta rada',
    //         optionsAttr: 'bs-options',
    //         ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
    //         valueProp: 'id',
    //         labelProp: 'naziv',
    //         placeholder: 'Odaberite vrstu rada',
    //         options: [
    //             {id: 'M', naziv: 'MOBILNA'},
    //             {id: 'F', naziv: 'FIKSNA'}
    //         ]
    //     }
    // },

    materijal: {
        key:'materijal',
        type: 'huiSelect',
        templateOptions: {
            label: 'Materijal',
            optionsAttr: 'bs-options',
            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
            valueProp: 'id',
            labelProp: 'naziv',
            placeholder: 'Odaberite materijal',
            options: []
        },
        controller: ['$scope', 'DS', function ($scope, DS) {
            DS.findAll('Materijal').then(function (response) {
                $scope.to.options = response;
            });
        }]
    },

    vrsta_rada: {
        key:'vrsta_rada',
        type: 'huiSelect',
        templateOptions: {
            label: 'Vrsta rada',
            optionsAttr: 'bs-options',
            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
            valueProp: 'id',
            labelProp: 'naziv',
            placeholder: 'Odaberite vrstu rada',
            options: [],
            required: true
        },
        controller: ['$scope', 'DS', function ($scope, DS) {
            DS.findAll('VrstaRada').then(function (response) {
                $scope.to.options = response;
            });
        }]
    },
    // protetski_rad: {
    //     key: 'protetski_rad',
    //     type: 'huiSelect',
    //     templateOptions: {
    //         label: 'Protetski rad',
    //         optionsAttr: 'bs-options',
    //         ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
    //         valueProp: 'id',
    //         labelProp: 'naziv',
    //         placeholder: 'Odaberite uslugu',
    //         options: [],
    //         required: true
    //     },
    //     controller: ['$scope', 'DS', function ($scope, DS) {
    //         $scope.$watch('model.vrsta_rada', function (newValue, oldValue) {
    //             if(newValue !== oldValue) {
    //                 if($scope.model[$scope.options.key] && oldValue) {
    //                     $scope.model[$scope.options.key] = '';
    //                 }
    //             }
    //             DS.findAll('ProtetskiRad').then(function (response) {
    //                 $scope.to.options = response.filter((i) => i.tip === newValue);
    //             });
    //         });
    //     }]
    // },
    protetski_rad: {
        key: 'protetski_rad',
        type: 'huiSelect',
        templateOptions: {
            label: 'Protetski rad',
            optionsAttr: 'bs-options',
            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
            valueProp: 'id',
            labelProp: 'naziv',
            placeholder: 'Odaberite uslugu',
            options: [],
            required: true
        },
        controller: ['$scope', 'DS', function ($scope, DS) {
            // DS.findAll('ProtetskiRad').then(function (response) {
            //     $scope.to.options = response;
            // });

            let radovi;

            function setProtetskiRad() {
                const vrsta_rada = $scope.model.vrsta_rada;
                const materijal = $scope.model.materijal;
                let opcije = [...radovi];

                $scope.model[$scope.options.key] = null;

                if (_.isFinite(parseInt(vrsta_rada))) {
                    opcije = opcije.filter((o) => o.vrsta_rada === vrsta_rada);
                }

                if (_.isFinite(parseInt(materijal))) {
                    opcije = opcije.filter((o) => o.materijal === materijal);
                }

                $scope.to.options = [...opcije];

                if (opcije.length === 1) {
                    $scope.model[$scope.options.key] = opcije[0].id;
                }
            }

            DS.findAll('StavkaCjenika').then((stavke) => {
                if (stavke && stavke.length > 0) {
                    DS.findAll('ProtetskiRad').then((protetskiRadovi) => {
                        $scope.to.options = protetskiRadovi.filter((i) => {
                            return _.find(stavke, {protetski_rad: i.id});
                        });
                        radovi = [...$scope.to.options];
                    });
                }
            });

            $scope.$watch('model.vrsta_rada', function (newValue, oldValue) {
                if(newValue !== oldValue) {
                    $scope.model.materijal = null;
                    setProtetskiRad();
                }
            });

            $scope.$watch('model.materijal', function (newValue, oldValue) {
                if(newValue !== oldValue) {
                    setProtetskiRad();
                }
            });
        }]
    },
    kolicina: {
        key: 'kolicina',
        type: 'input',
        templateOptions:{
            label: 'Komada',
            required: true
        }
    },
    napomena: {
        key: 'napomena',
        type: 'textarea',
        templateOptions: {
            label: 'Napomena',
            rows:4
        }
    },
    cjenik: {
        key: 'cjenik',
        type: 'huiSelect',
        templateOptions: {
            label: 'Cjenik',
            optionsAttr: 'bs-options',
            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
            valueProp: 'id',
            labelProp: 'naziv',
            placeholder: 'Odaberite cjenik',
            options: [],
            required: true
        },
        controller: ['$scope', 'DS', function ($scope, DS) {

            let cjenici, stavkeCjenika;

            function setCjenik() {
                const protetski_rad = parseInt($scope.model.protetski_rad);

                $scope.model[$scope.options.key] = null;

                if (_.isFinite(protetski_rad)) {
                    const stavke = stavkeCjenika.filter((s) => s.protetski_rad === protetski_rad);
                    $scope.to.options = cjenici.filter((c) => {
                        return _.find(stavke, {cjenik: c.id});
                    });

                    if ($scope.to.options.length === 1) {
                        $scope.model[$scope.options.key] = $scope.to.options[0].id;
                    }
                }
            }

            DS.findAll('StavkaCjenika').then((stavke) => {
                stavkeCjenika = [...stavke];
                DS.findAll('Cjenik').then(function (sviCjenici) {
                    cjenici = sviCjenici.filter((c) => {
                        return _.find(stavke, {cjenik: c.id});
                    });
                    $scope.to.options = [...cjenici];
                });
            });

            $scope.$watch('model.protetski_rad', function (newValue, oldValue) {
                if(newValue !== oldValue) {
                    setCjenik();
                }
            });


        }]
    }
};

export default function(ac, app) {
    var stavkaNaloga = app.getEntity('StavkaNaloga');

    stavkaNaloga.listView()
        .fields([
             ac.field('protetski_rad', 'reference')
                .targetEntity(app.getEntity('ProtetskiRad'))
                .targetField(ac.field('naziv'))
                .hidden(true),
            ac.field('pozicije', 'template')
                .label('Protetski rad<br/><small>Pozicija</small>')
                .template((entry) => {
                    return '<protetski-pozicije></protetski-pozicije>';
                }),
            ac.field('cjenik', 'reference')
                .label('Tip rada')
                .targetEntity(app.getEntity('Cjenik'))
                .targetField(ac.field('naziv')),
            ac.field('kolicina', 'template')
                .label('Količina')
                .template((entry)=> {
                    return entry.pozicije.length;
                }),
            // ac.field('napomena', 'template')
            //     .label('Napomena')
            //     .template((entry) => {
            //         return `<small>${entry.napomena}</small>`;
            //     })
            //     .cssClasses(['col-md-4']),
        ])
        // .references(app.getEntity('ProtetskiRad'))
        .listActions([
            'delete'
        ]);;


    // stavkaNaloga.creationView()
    //     .title('Odaberite pozicije za rad')
    //     .fields([
    //         Row([Column4([fields.cjenik]), Column4([fields.vrsta_rada])]),
    //         Row([Column8([fields.protetski_rad]), Column3([fields.kolicina])]),
    //         Row([Column12([fields.napomena])])
    //     ]);

     stavkaNaloga.creationView()
        .title('Odaberite pozicije za rad')
        .fields([
            // fields.vrsta_rada,
            // fields.materijal,
            fields.protetski_rad,
            fields.cjenik
            ]);

    return stavkaNaloga;
}



// WEBPACK FOOTER //
// ./app/components/stavkaNaloga/config.js